module.exports = __webpack_public_path__ + "static/img/main2_2.e0921eb2.png";